import { Col, Row } from "react-bootstrap";
import { SearchFieldPM } from "../../interfaces/AdvancedSearch/SearchFieldPM";
import { useEffect, useRef } from "react";
import FindCascadingCheckList, { CheckboxData } from "./FindCascadingCheckBoxList";

interface props {
    searchField: SearchFieldPM;
    onChange: (searchField: SearchFieldPM) => void;
    children: CheckboxData;
    history?: string | undefined;
}

function SearchFieldRowCascadingCheckList(props: props) {
    const inputFocusRef = useRef(false);

    const searchField = props.searchField;

    function setEnabled() {
        searchField.Enabled = !searchField.Enabled;

        if (searchField.Enabled) {
            inputFocusRef.current = true;
        }

        props.onChange(searchField);
    }

    function onInputColClick() {
        if (!searchField.Enabled) {
            setEnabled();
        }
    }

    const handleChecklistChange = (selected: string[]) => {
        const selectedString = selected.join(";");
        searchField.Value = selectedString;
        props.onChange(searchField);
    };

    return (
        <Row className="rowMarginControl">
            <Col xs={4}>
                <input
                    className="g-Checkbox-default"
                    type="checkbox"
                    checked={searchField.Enabled}
                    onChange={setEnabled}
                />
                <label
                    className="g-label"
                    onClick={setEnabled}
                >
                    {searchField.Label}
                </label>
            </Col>
            <Col
                xs={8}
                onClick={onInputColClick}
            >
                <FindCascadingCheckList
                    id={22}
                    label={props.searchField.Label}
                    enabledButton={searchField.Enabled}
                    onChange={handleChecklistChange}
                    history={props.history}
                >
                    {props.children}
                </FindCascadingCheckList>
            </Col>
        </Row>
    );
}

export default SearchFieldRowCascadingCheckList;
